var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-colored-el",
    fill: "#C1C1C1",
    fillRule: "evenodd",
    d: "M11 10l2.5 2.5a.707.707 0 01-1 1L10 11l-2.5 2.5a.707.707 0 01-1-1L9 10 6.5 7.5a.707.707 0 111-1L10 9l2.5-2.5a.707.707 0 111 1L11 10z"
  })));
};
export default SvgReset;